import { createSlice } from '@reduxjs/toolkit'

import { setConfig } from './configSlice'

const REDUCER_KEY = 'map'
export const MAP_REDUCER_KEY = REDUCER_KEY

const slice = createSlice({
    name: REDUCER_KEY,
    initialState: {
        center: null,
        showPopupFor: null,
        showTrackForTransportId: null,
        trackShown: false,
    },
    reducers: {
        moveMapTo: (state, { payload }) => {
            const { lat, lng, zoom } = payload

            if (!state.center) {
                state.center = {}
            }

            if ((lat && lng) || (lat === null && lng === null)) {
                state.center.lat = lat
                state.center.lng = lng
            }

            if (zoom) {
                state.center.zoom = zoom
            }
        },
        showPopup: (state, { payload }) => {
            state.showPopupFor = payload
        },
        hidePopup: (state, { payload }) => {
            if (state.showPopupFor === payload) {
                state.showPopupFor = null
            }
        },
        showTrack: (state, { payload }) => {
            if (state.showTrackForTransportId !== payload) {
                state.showTrackForTransportId = payload
                state.trackShown = false
            }
        },
        hideTrack: (state) => {
            state.showTrackForTransportId = null
            state.trackShown = false
        },
        toggleTrack: (state, { payload }) => {
            if (state.showTrackForTransportId === payload) {
                state.showTrackForTransportId = null
            } else {
                state.showTrackForTransportId = payload
            }

            state.trackShown = false
        },
        trackShown: (state, { payload }) => {
            if (state.showTrackForTransportId === payload) {
                state.trackShown = true
            }
        },
    },
    extraReducers: {
        [setConfig]: (state, { payload }) => {
            const { mapCenter } = payload

            if (!state.center) {
                state.center = mapCenter
            }
        },
    },
})

export const {
    moveMapTo,
    showPopup,
    hidePopup,
    showTrack,
    hideTrack,
    toggleTrack,
    trackShown,
} = slice.actions

const getState = state => state[REDUCER_KEY]
export const getMapCenter = state => getState(state).center
export const getShowPopupFor = state => getState(state).showPopupFor
export const getShownTrackTransportsId = state => getState(state).showTrackForTransportId
export const getIsTrackShown = state => getState(state).trackShown

export default slice.reducer
